export enum Source {
    WebStore = 0,
    Mac = 1,
    iPad = 2,
    iPhone = 3,
    Windows = 4,
    Android = 5,
  }
  